import { apiFetch } from './apiClient';

/**
 * Self-service compliance delete. Cascade-removes the caller's User row +
 * SavedPrompts + Conversations + ConversationMessages on the server side.
 * Idempotent (server returns 204 even if the user is already gone).
 *
 * `?confirm=true` is an affirmative-confirmation gate on the server, mirroring
 * `DELETE /admin/users/{id}?confirm=true`. Without it, the server returns 400.
 * The SPA's typed-DELETE dialog is the human-facing gate; this query-string
 * flag is the machine-readable equivalent (so a bare `curl -X DELETE /me`
 * with a stolen token can't trigger a wipe). Security audit CF.2 (2026-05-24).
 *
 * After a successful call, the SPA MUST call `instance.logoutRedirect()`.
 * If the user signs back in, EnsureUserMiddleware re-creates them with a
 * fresh User row + the seven default seeded prompts.
 */
export async function deleteMe(token: string): Promise<void> {
  const r = await apiFetch('/me?confirm=true', { token, method: 'DELETE' });
  if (!r.ok && r.status !== 204) throw new Error(`deleteMe: ${r.status}`);
}
